var _circle, _line, _line2, _line3, _line4, _circle2, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2835,
    cy: 13.7533,
    r: 6.72073,
    stroke: "#B1B1B1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.8955,
    y1: 0.753418,
    x2: 12.8955,
    y2: 5.0516,
    stroke: "#B1B1B1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8955,
    y1: 22.4552,
    x2: 12.8955,
    y2: 26.7534,
    stroke: "#B1B1B1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26.2832,
    y1: 13.351,
    x2: 21.985,
    y2: 13.351,
    stroke: "#B1B1B1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5813,
    y1: 13.351,
    x2: 0.283112,
    y2: 13.351,
    stroke: "#B1B1B1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2834,
    cy: 13.7533,
    r: 6.72073,
    transform: "rotate(45 13.2834 13.7533)",
    stroke: "#B1B1B1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 22.2015,
    y1: 4.28629,
    x2: 19.1622,
    y2: 7.32557,
    stroke: "#B1B1B1"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.85599,
    y1: 19.6319,
    x2: 3.81672,
    y2: 22.6712,
    stroke: "#B1B1B1"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7602,
    y1: 22.661,
    x2: 19.7209,
    y2: 19.6218,
    stroke: "#B1B1B1"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 7.415,
    y1: 7.31571,
    x2: 4.37572,
    y2: 4.27643,
    stroke: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighModeIcon);
export default __webpack_public_path__ + "static/media/lighModeIcon.5f4e8250c7a063a550d718fba5c68dea.svg";
export { ForwardRef as ReactComponent };